import { FolderTileProps } from '../kb.props';

function FolderTile({ name, onClick }: FolderTileProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
      className="flex items-center justify-start border-[1px] border-[#E4E4E7] rounded-lg py-2 px-4 hover:bg-gray-50 transition"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-10 w-10 text-blue-600 mb-2"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M3 7h4l2 2h10v10H3V7z"
        />
      </svg>
      <span className="text-base font-semibold">{name}</span>
    </div>
  );
}

export default FolderTile;
